import pickyEater from './artikel/picky-eater.jpg'
import sharenting from './artikel/sharenting.jpg'
import berpisahTanpaTrauma from './artikel/berpisah-tanpa-trauma.jpg'
import cctvEtis from './artikel/cctv-etis.jpg'
import satuSuara from './artikel/satu-suara.jpg'

const artikelImages = {
  'picky-eater': pickyEater,
  'sharenting': sharenting,
  'berpisah-tanpa-trauma': berpisahTanpaTrauma,
  'cctv-etis': cctvEtis,
  'satu-suara': satuSuara,
}

export default artikelImages
